import React from "react";
const CustomBadge = ({
    count,
    overflowCount = 99,
    children,
}: {
    count: number;
    overflowCount?: number;
    children: React.ReactNode;
}) => {
    const displayCount = count > overflowCount ? `${overflowCount}+` : count;

    return (
        <div style={{ position: "relative", display: "inline-block" }}>
            {children}
            {count > 0 && (
                <span
                    style={{
                        position: "absolute",
                        top: "-8px",
                        right: "-8px",
                        backgroundColor: "#ff4d4f",
                        color: "white",
                        fontSize: "12px",
                        fontWeight: "bold",
                        borderRadius: "50%",
                        width: "18px",
                        height: "18px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 0 0 1px #fff",
                        pointerEvents: "none",
                    }}
                >
                    {displayCount}
                </span>
            )}
        </div>
    );
};

export default CustomBadge;
